/**
 * Metrics Cards Component
 *
 * Displays supplementary KPI cards for metrics not shown in charts
 */

import { MetricCard } from './MetricCard';
import { METRIC_DESCRIPTIONS } from './MetricDescriptions';
import { formatDecimal } from '@/lib/formatters';
import type { MetricsSummary } from '@/types/dashboard';

interface MetricsCardsProps {
  data: MetricsSummary | null | undefined;
  isLoading: boolean;
}

export function MetricsCards({ data, isLoading }: MetricsCardsProps) {
  // Show skeleton when loading OR when data hasn't arrived yet
  const showSkeleton = isLoading || data === null || data === undefined;

  return (
    <MetricCard
      title="Avg Docs Retrieved"
      value={formatDecimal(data?.avgDocumentsRetrieved)}
      description="Average documents per query"
      isLoading={showSkeleton}
      tooltip={METRIC_DESCRIPTIONS.avgDocsRetrieved}
    />
  );
}
